//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, BindsAttrs } from '@/mixins'
import queryString from 'query-string'

export default {
  mixins: [ UsesAuthenticatedUser, BindsAttrs ],
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    text: {
      type: String,
      required: false,
      default: '',
    },
    kintellCard: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      excitedPerson: require('~images/excited-person.svg'),
      showEmbedCode: false,
      loadingKintellCardShortLink: false
    }
  },
  computed: {
    mailShare () {
      const query = queryString.stringify({
        subject: this.title,
        body: this.text + ' ' + this.shareLink,
      })
      return 'mailto:?' + query
    },
    embedCode () {
      return '<iframe style="box-shadow: 0 15px 35px 0 rgba(50, 50, 93, 0.1);" width="300" height="390"  frameborder="0" scrolling="no" src="' + this.embedLink + '/embed' + '"></iframe>'
    },
    shareLink () {
      // If the kintell card has not been loaded yet then exit out
      if (!this.kintellCard || !this.kintellCard.shortLink) {
        return
      }
      return this.kintellCard.shortLink
    },
    embedLink () {
      // If the kintell card has not been loaded yet then exit out
      if (!this.kintellCard) {
        return
      }
      // using id in case user changes their kintell card or name (unlikely)
      return window.location.origin + '/advisors/' + this.kintellCard.createdBy + '/' + this.kintellCard.id
    },
    isOwnCard () {
      return this.authenticatedUser && this.authenticatedUser.id === this.kintellCard.createdBy
    }
  },
  watch: {
    value (val) {
      if (val && this.kintellCard && !this.kintellCard.shortLink) {
        this.createShortLink()
      }
    }
  },
  methods: {
    copyEmbedCodeToClipboard () {
      this.$refs.codeSnippet.select()
      document.execCommand('copy')
      this.$toast.success('Embed code snippet copied')
    },
    async createShortLink () {
      this.loadingKintellCardShortLink = true
      await this.kintellCard.fetchShortLink()
      this.loadingKintellCardShortLink = false
    }
  }
}
